'use client';

import {Avatar, AvatarFallback} from '@purpose/ui/components/avatar/avatar';
import {useResponsive} from '@purpose/ui/hooks/useResponsive';
import {cn} from '@purpose/ui/lib/utils';
import DefaultAvatar from '../../assets/icons/AvatarFallback.svg';
import Image from 'next/image';
import {Typography} from '../typography';

interface UserHeaderInfoProps {
  userName?: string | null;
  avatarUrl?: string | null;
  onClick?: () => void;
}

const UserHeaderInfo = ({
  userName,
  avatarUrl,
  onClick
}: UserHeaderInfoProps) => {
  const {isTabletOrSmaller} = useResponsive();

  return (
    <div className="flex cursor-pointer items-center gap-4" onClick={onClick}>
      <Avatar className={cn('rounded-full', 'size-12')}>
        {avatarUrl ? (
          <img
            src={avatarUrl}
            alt={userName || ''}
            className="h-full w-full rounded-full object-cover"
          />
        ) : (
          <AvatarFallback>
            <Image src={DefaultAvatar} width={48} height={48} alt="avatar" />
          </AvatarFallback>
        )}
      </Avatar>
      <Typography className="text-white" variant="body1">
        {userName}
      </Typography>
    </div>
  );
};

export {UserHeaderInfo};
export type {UserHeaderInfoProps};
